import React from 'react';
import { RisksReviewsChipValues } from '@pages-clean/risk-assessment/critical-to-quality-factors/types';
import { NullableStudy } from '@contexts/local-state-context';
import { CriticalVariableFields } from '@queries/generated/fragments.generated';

export interface IFormData {
    study: NullableStudy | undefined;
    selectionState: SelectionState;
    riskGridIsFiltered: boolean;
    functionalDataReviewsGridIsFiltered: boolean;
    selectedChildTab: RisksReviewsChipValues;
}

export type SelectionState = {
    recordId?: string;
    selectedItemsCount: number;
    bulkUpdateRows: SelectedRowsProps[];
    selectedItem?: CriticalVariableFields;
};

export interface SelectedRowsProps {
    id: number;
}

interface IContext {
    current: IFormData;
    setCurrent: React.Dispatch<React.SetStateAction<IFormData>>;
    setSelectionState: React.Dispatch<React.SetStateAction<SelectionState>>;
}

export const CTQFactorsContext = React.createContext<IContext>(undefined!);
